import React, { useState } from "react";
import api from "../../api/axios";

const TestimonialModal = ({ show, onClose, onCreated }) => {
  const [form, setForm] = useState({
    person_name: "",
    person_occupation: "",
    feedback: "",
    image: null,
  });

  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm({
      ...form,
      [name]: files ? files[0] : value,
    });
  };

  const submitHandler = async (e) => {
  e.preventDefault();

  if (!form.image) {
    alert("Image is required");
    return;
  }

  const formData = new FormData();
  formData.append("person_name", form.person_name);
  formData.append("person_occupation", form.person_occupation);
  formData.append("feedback", form.feedback);
  formData.append("image", form.image);

  try {
    setLoading(true);

    await api.post(
      "companyblog/admin/testimonials/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    onCreated();   // refresh list
    onClose();     // close modal

    // reset form
    setForm({
      person_name: "",
      person_occupation: "",
      feedback: "",
      image: null,
    });

  } catch (err) {
    console.error(err.response?.data);
    alert("Failed to create testimony");
  } finally {
    setLoading(false);
  }
};


  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Create Testimony</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <form onSubmit={submitHandler}>
            <div className="modal-body">

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Person's Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="person_name"
                    value={form.person_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Job *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="person_occupation"
                    value={form.person_occupation}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Testimony Image *</label>
                  <input
                    type="file"
                    className="form-control"
                    name="image"
                    onChange={handleChange}
                    required
                  />
                  <small className="text-muted">
                    Required dimension is <b>1680 × 1120 px</b>
                  </small>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Feedback *</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="feedback"
                    value={form.feedback}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>

              <button
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default TestimonialModal;
